import { Typography } from "@mui/material";
import type { BooleanObjectFilter } from "../../api/types/objectTypes";
import { getBooleanFilterValueText } from "./objectFilterHelpers";

interface Props {
  fieldName: string;
  filter: BooleanObjectFilter;
  startLabel: string;
}

const ObjectBooleanFilterDescription = ({ fieldName, filter, startLabel }: Props) => {
  return (
    <Typography>
      {startLabel} <strong>{fieldName}</strong> is <strong>{getBooleanFilterValueText(filter)}</strong>
    </Typography>
  );
};

export default ObjectBooleanFilterDescription;
